import Box from "@mui/material/Box";
import React, { FC, ReactNode, useState, useRef, useEffect } from "react";
import {
  StyledToolbarContainerAbove,
  StyledToolbarContainerBelow,
} from "./styled";

type CustomTooltipProps = {
  title: ReactNode;
  children: ReactNode;
  width?: string;
};

const CustomTooltip: FC<CustomTooltipProps> = ({ title, children, width }) => {
  const [hovered, setHovered] = useState(false);
  const [showAbove, setShowAbove] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (hovered && containerRef.current && tooltipRef.current) {
      const boundingRect = containerRef.current.getBoundingClientRect();
      const tooltipHeight = tooltipRef.current.offsetHeight + 16;
      const spaceAbove = boundingRect.top;

      setShowAbove(spaceAbove >= tooltipHeight);
    }
  }, [hovered]);

  return (
    <Box
      ref={containerRef}
      display="inline-block"
      alignItems="center"
      position="relative"
      maxWidth="100%"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
      {hovered &&
        (showAbove ? (
          <StyledToolbarContainerAbove ref={tooltipRef} width={width}>
            {title}
          </StyledToolbarContainerAbove>
        ) : (
          <StyledToolbarContainerBelow ref={tooltipRef} width={width}>
            {title}
          </StyledToolbarContainerBelow>
        ))}
    </Box>
  );
};

export default CustomTooltip;
